import { PickersActionBar } from "@mui/x-date-pickers/PickersActionBar";

export function DatePickerMobileActionBar({ onSetDefaultDate, ...props }: any) {
	return (
		<PickersActionBar
			{...props}
			onAccept={() => {
				onSetDefaultDate?.();
				props.onAccept();
			}}
		/>
	);
}
